import script from "./violations.vue?vue&type=script&setup=true&lang=js"
export * from "./violations.vue?vue&type=script&setup=true&lang=js"

import "./violations.vue?vue&type=style&index=0&id=d82de9de&scoped=true&lang=css"

import exportComponent from "/home/dev.qpax-tcms.net/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d82de9de"]])

export default __exports__